import { checkCodecsSupported, KNOWN_CODECS } from 'utils/codecsChecker';
import { promisify } from 'utils/helpers';

export const resolveRTCPeerConnection: () => typeof RTCPeerConnection = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
};

export const resolveRTCIceCandidate: () => typeof RTCIceCandidate = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate;
};

export const resolveRTCSessionDescription: () => typeof RTCSessionDescription = () => {
  return (
    window.RTCSessionDescription ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.mozRTCSessionDescription ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.webkitRTCSessionDescription
  );
};

export const resolveGetUserMedia: () => typeof navigator.mediaDevices.getUserMedia = () => {
  const gUMRef: typeof navigator.mediaDevices.getUserMedia =
    navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices) ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (navigator.getUserMedia && promisify(navigator.getUserMedia.bind(navigator))) ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (navigator.webkitGetUserMedia && promisify(navigator.webkitGetUserMedia.bind(navigator))) ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (navigator.mozGetUserMedia && promisify(navigator.mozGetUserMedia.bind(navigator)));

  return (constraints?: MediaStreamConstraints) => gUMRef.call(navigator, constraints);
};

export const getIsWebRTCApiSupported: () => boolean = () => {
  return Boolean(
    resolveRTCPeerConnection() && resolveRTCIceCandidate() && resolveRTCSessionDescription(),
  );
};

const isH264PlayingSupported: () => Promise<boolean> = async () => {
  const supportedCodecs: string[] = await checkCodecsSupported('play', [
    KNOWN_CODECS.H264,
    KNOWN_CODECS.VP8,
  ]);

  return supportedCodecs.some((codec) => [KNOWN_CODECS.H264, KNOWN_CODECS.VP8].includes(codec));
};

const isH264BroadcastSupported: () => Promise<boolean> = async () => {
  const supportedCodecs: string[] = await checkCodecsSupported('broadcast', [
    KNOWN_CODECS.H264,
    KNOWN_CODECS.VP8,
  ]);

  return supportedCodecs.some((codec) => [KNOWN_CODECS.H264, KNOWN_CODECS.VP8].includes(codec));
};
export const WebRTCCommonHelpers = {
  getIsWebRTCApiSupported,
  resolveGetUserMedia,
  resolveRTCPeerConnection,
  resolveRTCIceCandidate,
  resolveRTCSessionDescription,
  isH264BroadcastSupported,
  isH264PlayingSupported,
};
